module.exports = __webpack_public_path__ + "static/media/page-not-found.8277bb7d.svg";